"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneInput = void 0;
var _composeReactRefs = _interopRequireDefault(require("@seznam/compose-react-refs"));
var _themeGet = require("@styled-system/theme-get");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledSystem = require("styled-system");
var _utils = require("../../utils");
var _Box = require("../Box");
var _Input = require("../Input");
var _Text = require("../Text");
var _tokens = require("./tokens");
var _useKeyboardListNavigation = require("use-keyboard-list-navigation");
var _RequiredField = require("../../shared/RequiredField");
var _excluded = ["className", "options", "disabled", "error", "focus", "hover", "required", "onSelect", "dropdownValue", "inputValue"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * The option structure for the list in the dropdown menu
 *
 * @interface Option
 * @property {string} `text` is the content that will be displayed as selected option
 * @property {string} `name` is the content that will be displayed in the dropdown list
 * @property {string} `value` is the value that will be passed to onSelect
 */

var PhoneInput = /*#__PURE__*/_react.default.forwardRef(function (_ref, forwardedRef) {
  var className = _ref.className,
    options = _ref.options,
    disabled = _ref.disabled,
    error = _ref.error,
    focus = _ref.focus,
    hover = _ref.hover,
    required = _ref.required,
    onSelect = _ref.onSelect,
    dropdownValue = _ref.dropdownValue,
    inputValue = _ref.inputValue,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (options.length === 0) {
    throw new Error("Palette PhoneInput requires at least 1 option in the options prop");
  }
  var inputRef = (0, _react.useRef)(null);
  var searchInputRef = (0, _react.useRef)(null);
  var containerRef = (0, _react.useRef)(null);
  var countryPickerRef = (0, _react.useRef)(null);
  var defaultOption = (0, _react.useMemo)(function () {
    return dropdownValue && options.find(function (option) {
      return option.value === dropdownValue;
    });
  }, [dropdownValue, options]);
  var _splitBoxProps = (0, _Box.splitBoxProps)(rest),
    _splitBoxProps2 = _slicedToArray(_splitBoxProps, 2),
    boxProps = _splitBoxProps2[0],
    inputProps = _splitBoxProps2[1];
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDropdownVisible = _useState2[0],
    setDropdownVisible = _useState2[1];
  var _useState3 = (0, _react.useState)(""),
    _useState4 = _slicedToArray(_useState3, 2),
    searchQuery = _useState4[0],
    setSearchQuery = _useState4[1];
  var _useState5 = (0, _react.useState)(defaultOption || options[0]),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedOption = _useState6[0],
    setSelectedOption = _useState6[1];
  var filteredOptions = options.filter(function (option) {
    if (searchQuery !== "") {
      var filteredCountry = option.text.toLowerCase().includes(searchQuery.toLowerCase()) || option.name.toLowerCase().includes(searchQuery.toLowerCase());
      return filteredCountry;
    }
    return true;
  });
  var _usePosition = (0, _utils.usePosition)({
      key: filteredOptions.length,
      position: "bottom",
      offset: 10,
      active: isDropdownVisible,
      flip: false
    }),
    anchorRef = _usePosition.anchorRef,
    tooltipRef = _usePosition.tooltipRef;
  var _useKeyboardListNavig = (0, _useKeyboardListNavigation.useKeyboardListNavigation)({
      ref: containerRef,
      list: filteredOptions,
      waitForInteractive: true,
      onEnter: function onEnter(_ref2) {
        var option = _ref2.element,
          event = _ref2.event;
        event.preventDefault();
        event.stopPropagation();
        if (option) {
          handleSelect(option);
        }
        resetUI();
      }
    }),
    reset = _useKeyboardListNavig.reset,
    set = _useKeyboardListNavig.set;
  var _useWidthOf = (0, _utils.useWidthOf)({
      ref: anchorRef
    }),
    width = _useWidthOf.width;
  var inputName = inputProps.name || "palette-phone-input";
  var optionsWithRefs = (0, _react.useMemo)(function () {
    return filteredOptions.map(function (option) {
      return {
        option: option,
        ref: /*#__PURE__*/(0, _react.createRef)()
      };
    });
  }, [filteredOptions]);
  var resetUI = function resetUI() {
    setTimeout(function () {
      var _inputRef$current;
      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
      reset();
      setDropdownVisible(false);
    }, 100);
  };
  var handleSelect = function handleSelect(option) {
    var _inputRef$current2;
    (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.focus();
    setSearchQuery("");
    setSelectedOption(option);
    setDropdownVisible(false);
    onSelect === null || onSelect === void 0 ? void 0 : onSelect(option);
  };
  var handleFocusChange = (0, _react.useCallback)(function (focused) {
    if (focused || !isDropdownVisible) return;
    setDropdownVisible(false);
  }, [isDropdownVisible]);

  // Handle closing the dropdown when clicking outside of the input
  // or when focus leaves the input completely
  var _useContainsFocus = (0, _utils.useContainsFocus)({
      onChange: handleFocusChange
    }),
    containsFocusRef = _useContainsFocus.ref;
  var handleCountryPickerKeydown = function handleCountryPickerKeydown(event) {
    var _countryPickerRef$cur;
    switch (event.key) {
      case "Escape":
        event.preventDefault();
        event.stopPropagation();
        setDropdownVisible(false);
        (_countryPickerRef$cur = countryPickerRef.current) === null || _countryPickerRef$cur === void 0 ? void 0 : _countryPickerRef$cur.blur();
        reset();
        return;
      case "Enter":
      case " ":
        event.preventDefault();
        event.stopPropagation();
        if (!disabled) {
          setDropdownVisible(true);
        }
        return;
    }
  };
  var handleSearchInputKeydown = function handleSearchInputKeydown(event) {
    var _searchInputRef$curre;
    switch (event.key) {
      case "Tab":
        if (event.shiftKey) {
          // ignore
        } else {
          // move down to the list
          event.preventDefault();
          event.stopPropagation();
          reset();
          set({
            cursor: 0,
            interactive: true
          });
        }
        return;
      case "Enter":
        event.preventDefault();
        event.stopPropagation();
        if (filteredOptions.length) {
          handleSelect(filteredOptions[0]);
        }
        return;
      default:
        (_searchInputRef$curre = searchInputRef.current) === null || _searchInputRef$curre === void 0 ? void 0 : _searchInputRef$curre.focus();
    }
  };
  return /*#__PURE__*/_react.default.createElement(_Box.Box, _extends({
    ref: (0, _composeReactRefs.default)(containerRef, containsFocusRef),
    width: "100%",
    className: className
  }, boxProps), /*#__PURE__*/_react.default.createElement(ContainerBox, {
    ref: anchorRef,
    isDropdownVisible: isDropdownVisible,
    hover: hover,
    focus: focus,
    error: error,
    disabled: disabled,
    placeholder: inputProps.placeholder
  }, /*#__PURE__*/_react.default.createElement(SelectContainer, {
    "data-testid": "country-picker",
    ref: countryPickerRef,
    disabled: disabled,
    onClick: function onClick() {
      setDropdownVisible(!disabled && !isDropdownVisible);
    },
    tabIndex: disabled ? -1 : 0,
    onKeyDown: handleCountryPickerKeydown
  }, selectedOption.text), /*#__PURE__*/_react.default.createElement(StyledInput, _extends({
    disabled: disabled,
    ref: (0, _composeReactRefs.default)(inputRef, forwardedRef),
    type: "tel",
    autoComplete: "tel-national",
    required: required,
    name: inputName,
    maxLength: 25,
    placeholder: inputProps.placeholder,
    value: inputValue
  }, inputProps)), /*#__PURE__*/_react.default.createElement(StyledLabel, {
    htmlFor: inputName
  }, "Phone Number", /*#__PURE__*/_react.default.createElement("span", null))), isDropdownVisible && /*#__PURE__*/_react.default.createElement(SelectDropdown, {
    ref: tooltipRef,
    role: "listbox",
    width: width
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    ref: searchInputRef,
    p: 1,
    pb: 0,
    autoFocus: true,
    placeholder: "Search",
    value: searchQuery,
    onChange: function onChange(e) {
      return setSearchQuery(e.target.value);
    },
    onKeyDown: handleSearchInputKeydown
  }), /*#__PURE__*/_react.default.createElement(SelectOptions, null, optionsWithRefs.map(function (_ref3, i) {
    var option = _ref3.option,
      ref = _ref3.ref;
    return /*#__PURE__*/_react.default.createElement(SelectOption, {
      key: i,
      ref: ref,
      role: "option",
      "aria-selected": option.value === selectedOption.value,
      "aria-posinset": i + 1,
      "aria-setsize": options.length,
      selected: option.value === selectedOption.value,
      onClick: function onClick() {
        return handleSelect(option);
      },
      tabIndex: -1
    }, /*#__PURE__*/_react.default.createElement(_Text.Text, {
      minWidth: 80
    }, option.text), /*#__PURE__*/_react.default.createElement(_Text.Text, null, option.name));
  }))), required && !(error && typeof error === "string") && /*#__PURE__*/_react.default.createElement(_RequiredField.RequiredField, {
    mt: 0.5,
    ml: 1,
    disabled: disabled
  }), error && typeof error === "string" && /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "xs",
    mt: 0.5,
    mr: 1,
    color: "red100",
    textAlign: "right"
  }, error));
});
exports.PhoneInput = PhoneInput;
PhoneInput.displayName = "PhoneInput";
var caretMixin = (0, _styledComponents.css)(["&::after{content:\"\";cursor:inherit;width:0;height:0;position:absolute;top:50%;transform:translateY(-50%);right:", ";pointer-events:none;border-left:4px solid transparent;border-right:4px solid transparent;border-top:4px solid ", ";}"], (0, _themeGet.themeGet)("space.1"), function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled ? (0, _themeGet.themeGet)("colors.black10") : (0, _themeGet.themeGet)("colors.black60");
});
var ContainerBox = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "PhoneInput__ContainerBox",
  componentId: "lj1bt9-0"
})(["position:relative;display:flex;flex-direction:row;", ""], function (props) {
  return (0, _styledComponents.css)(["", " ", " ", " ", " ", " &:hover{", "}&:focus-within{", " &:has(input:not(:placeholder-shown)){", " ", ";}}&:has(input:not(:placeholder-shown)){", " ", ";}"], _tokens.PHONE_INPUT_STATES.default, props.hover && _tokens.PHONE_INPUT_STATES.hover, (props.focus || props.isDropdownVisible) && _tokens.PHONE_INPUT_STATES.focus, props.disabled && _tokens.PHONE_INPUT_STATES.disabled, props.error && _tokens.PHONE_INPUT_STATES.error, !props.isDropdownVisible && !props.disabled && _tokens.PHONE_INPUT_STATES.hover, !props.disabled && _tokens.PHONE_INPUT_STATES.focus, _tokens.PHONE_INPUT_STATES.active, props.error && _tokens.PHONE_INPUT_STATES.error, !!props.placeholder && _tokens.PHONE_INPUT_STATES.completed, props.error && _tokens.PHONE_INPUT_STATES.error);
});
var SelectContainer = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "PhoneInput__SelectContainer",
  componentId: "lj1bt9-1"
})(["display:flex;align-items:center;position:relative;min-width:120px;border:1px solid;border-right:0;padding:0 24px 0 ", ";font-family:", ";border-radius:3px 0 0 3px;border-color:", ";cursor:pointer;line-height:1;transition:color 0.25s,border-color 0.25s;height:50px;font-size:", ";color:", ";", ""], (0, _themeGet.themeGet)("space.1"), (0, _themeGet.themeGet)("fonts.sans"), (0, _themeGet.themeGet)("colors.black30"), (0, _themeGet.themeGet)("textVariants.sm-display.fontSize"), (0, _themeGet.themeGet)("colors.black100"), caretMixin);
var SelectDropdown = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "PhoneInput__SelectDropdown",
  componentId: "lj1bt9-2"
})(["box-shadow:", ";z-index:1;background:", ";"], (0, _themeGet.themeGet)("effects.dropShadow"), (0, _themeGet.themeGet)("colors.white100"));
var SelectOptions = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "PhoneInput__SelectOptions",
  componentId: "lj1bt9-3"
})(["max-height:308px;overflow-y:auto;-webkit-overflow-scrolling:touch;padding:", ";"], (0, _themeGet.themeGet)("space.1"));
var SelectOption = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "PhoneInput__SelectOption",
  componentId: "lj1bt9-4"
})(["padding:", " 0;cursor:pointer;display:flex;flex-direction:row;align-items:center;text-decoration:none;color:", ";transition:color 0.25s,text-decoration 0.25s;&:hover{color:", ";text-decoration:underline;}&:focus,&:active{color:", ";text-decoration:none;}", ""], (0, _themeGet.themeGet)("space.1"), (0, _themeGet.themeGet)("colors.black60"), (0, _themeGet.themeGet)("colors.blue100"), (0, _themeGet.themeGet)("colors.black100"), function (props) {
  return props.selected && (0, _styledComponents.css)(["color:", ";text-decoration:none;"], (0, _themeGet.themeGet)("colors.black100"));
});
var StyledInput = _styledComponents.default.input.withConfig({
  displayName: "PhoneInput__StyledInput",
  componentId: "lj1bt9-5"
})(["width:100%;background-color:", ";padding:0 ", ";appearance:none;outline:none;line-height:1;border:1px solid;border-radius:0 3px 3px 0;transition:color 0.25s,border-color 0.25s;font-family:", ";font-size:", ";color:", ";border-color:", ";", "::placeholder{color:", ";transition:color 0.25s;}"], (0, _themeGet.themeGet)("colors.white100"), (0, _themeGet.themeGet)("space.1"), (0, _themeGet.themeGet)("fonts.sans"), (0, _themeGet.themeGet)("textVariants.sm-display.fontSize"), (0, _themeGet.themeGet)("colors.black100"), (0, _themeGet.themeGet)("colors.black30"), _styledSystem.height, (0, _themeGet.themeGet)("colors.black60"));
var StyledLabel = _styledComponents.default.label.withConfig({
  displayName: "PhoneInput__StyledLabel",
  componentId: "lj1bt9-6"
})(["position:absolute;top:0;left:5px;padding:0 5px;background-color:transparent;transform:translateY(-50%);transition:color 0.25s;font-family:", ";pointer-events:none;font-size:", ";color:", ";& > span{background-color:", ";height:2px;width:100%;display:block;position:absolute;top:50%;left:0;z-index:-1;}"], (0, _themeGet.themeGet)("fonts.sans"), (0, _themeGet.themeGet)("textVariants.xs.fontSize"), (0, _themeGet.themeGet)("colors.black60"), (0, _themeGet.themeGet)("colors.white100"));
//# sourceMappingURL=PhoneInput.js.map